var render, staticRenderFns
import script from "./ChartComponentVulnerabilities.vue?vue&type=script&lang=js&"
export * from "./ChartComponentVulnerabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3289c54')) {
      api.createRecord('f3289c54', component.options)
    } else {
      api.reload('f3289c54', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/ChartComponentVulnerabilities.vue"
export default component.exports